"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get VISIT_TYPE_LABELS () {
        return VISIT_TYPE_LABELS;
    },
    get VisitTypeSchema () {
        return VisitTypeSchema;
    }
});
const _zod = require("zod");
const VisitTypeSchema = _zod.z.enum([
    'consultation',
    'follow_up',
    'first_encounter',
    'procedure',
    'lab_review'
]);
const VISIT_TYPE_LABELS = {
    consultation: 'Consultation',
    follow_up: 'Follow-up',
    first_encounter: 'First encounter',
    procedure: 'Procedure',
    lab_review: 'Lab review'
};
